import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { RadioGroupInputWUT } from "../../inputs/radio-group-input-wut/radio-group-input-wut.js";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldErrorWUT } from "../field-error/field-error-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { NUMBER_OF_COLUMNS } from "../options-layout/options-layout-constants.js";
import { Widget } from "../widget/widget.js";
const RadioGroupFieldWUT = ({
  id,
  target,
  label,
  hideLabel = false,
  options,
  description,
  addOther,
  addOtherLabel,
  addOtherPlaceholder,
  required,
  value,
  onChange,
  onFocus,
  onBlur,
  error,
  hasError = false,
  errorMessage,
  disabled = false,
  otherInputCharacterLimit,
  FieldLayout,
  numberOfColumns = NUMBER_OF_COLUMNS.ONE,
  media,
  mediaSettings,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          required,
          label,
          hideLabel,
          media,
          mediaSettings,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        RadioGroupInputWUT,
        {
          target,
          inputId,
          labelId,
          hasError,
          options,
          ariaDescribedBy,
          addOther,
          addOtherLabel,
          addOtherPlaceholder,
          required,
          value,
          onChange,
          onFocus,
          onBlur,
          disabled,
          otherInputCharacterLimit,
          numberOfColumns,
          fieldId: id
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  RadioGroupFieldWUT
};
//# sourceMappingURL=radio-group-field-wut.js.map
